module.exports = __webpack_public_path__ + "static/media/hero-big.c2e68d51.webp";